import { ReactNode } from 'react'
import { faPen } from '@fortawesome/pro-regular-svg-icons'
import { Link, Icon, Text } from '@/ui'

interface PencilLinkOrTextProps {
  children: ReactNode
  isActiveEstimate: boolean
  hideLink?: boolean
}

export const PencilLinkOrText = ({
  children,
  isActiveEstimate,
  hideLink,
}: PencilLinkOrTextProps) => {
  if (!hideLink && isActiveEstimate) {
    return (
      <Link href="/taxes/quarterly/recalculate">
        {children}
        <Icon icon={faPen} className="ml-2" />
      </Link>
    )
  }

  return <Text className={isActiveEstimate ? 'mr-7' : ''}>{children}</Text>
}
